module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2InvestmentName.a4f945e4f4a7444d07ffc19d7805ab8c.png";